var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree_container"},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.treeData,"props":_vm.defaultProps,"accordion":"","default-expanded-keys":_vm.treeExpandData,"default-checked-keys":[_vm.currentNode],"highlight-current":true,"node-key":"name"},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }